import Button from '@hero/ui-kit/inputs/Button';
import Form, { useFormContext } from '@hero/ui-kit/inputs/Form';
import TextArea from '@hero/ui-kit/inputs/TextArea';
import Section from '@hero/ui-kit/layout/Section';
import React from 'react';

import * as yup from 'yup';
import QueryInlineError from '../../../../components/QueryInlineError';
import { toast } from 'sonner';
import useSmsReply from '../../api/useSmsReply';

const smsSchema = yup
    .object()
    .shape({
        message: yup.string().required('Message is required')
    })
    .defined();

export type SmsSchemaParams = yup.InferType<typeof smsSchema>;

const FormElements: React.FC<{ isActionPending: boolean; disabled?: boolean }> = ({
    isActionPending,
    disabled
}) => {
    const {
        formState: { isValid },
        reset
    } = useFormContext();

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '1rem'
                }}
            >
                <TextArea
                    name="message"
                    displayName=""
                    placeholder="Type your message here..."
                    rows={2}
                    styles={{ marginBottom: 0 }}
                />
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '1rem'
                    }}
                >
                    <Button type="submit" disabled={isActionPending || !isValid || disabled}>
                        {isActionPending ? 'Sending...' : 'Send'}
                    </Button>
                    <Button variant="outlineSecondary" type="button" onClick={() => reset()}>
                        Clear
                    </Button>
                </div>
            </div>
        </>
    );
};

type AddNoteFormProps = {
    prospectId: string;
    disabled?: boolean;
};

const ReplySmsForm: React.FC<AddNoteFormProps> = ({ prospectId, disabled }) => {
    const { mutateAsync: smsReply, isPending: isActionPending, error } = useSmsReply();

    const handleSubmit = (values: SmsSchemaParams) => {
        smsReply({
            prospect_id: prospectId,
            message: values.message
        }).then(() => {
            toast.success('Message sent successfully');
        });
    };

    return (
        <Section noDefaultPadding>
            <Form validationSchema={smsSchema} submitFn={handleSubmit}>
                <FormElements disabled={disabled} isActionPending={isActionPending} />
                {error ? <QueryInlineError centered error={error} /> : null}
            </Form>
        </Section>
    );
};

export default ReplySmsForm;
